webpackJsonp([35783957827783],{

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CookieBannerContainer = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(["\n  flex: 1;\n  margin-top: 0;\n  ", ";\n  ", ";\n  max-width: unset;\n  width: 100%;\n  -webkit-text-size-adjust: 100%;\n\n  a {\n    color: ", ";\n    text-decoration: underline;\n\n    :hover {\n      color: ", ";\n    }\n  }\n"], ["\n  flex: 1;\n  margin-top: 0;\n  ", ";\n  ", ";\n  max-width: unset;\n  width: 100%;\n  -webkit-text-size-adjust: 100%;\n\n  a {\n    color: ", ";\n    text-decoration: underline;\n\n    :hover {\n      color: ", ";\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(80, 80, 80, 0.9);\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  width: 100%;\n  ", ";\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(80, 80, 80, 0.9);\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  width: 100%;\n  ", ";\n  ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  max-width: 1280px;\n  width: 100%;\n  position: relative;\n  display: flex;\n  ", ";\n  ", ";\n  ", ";\n  justify-content: space-between;\n"], ["\n  max-width: 1280px;\n  width: 100%;\n  position: relative;\n  display: flex;\n  ", ";\n  ", ";\n  ", ";\n  justify-content: space-between;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  ", ";\n  ", ";\n"], ["\n  position: absolute;\n  ", ";\n  ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 9;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ", ";\n  opacity: 0.7;\n"], ["\n  position: fixed;\n  z-index: 9;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ", ";\n  opacity: 0.7;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 98;\n"], ["\n  position: relative;\n  z-index: 98;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _buoyButton = __webpack_require__(48);
	
	var _buoyButton2 = _interopRequireDefault(_buoyButton);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _buoyTheme = __webpack_require__(4);
	
	var _buoyRawHtml = __webpack_require__(228);
	
	var _buoyRawHtml2 = _interopRequireDefault(_buoyRawHtml);
	
	var _buoyText = __webpack_require__(20);
	
	var _buoyCloseIcon = __webpack_require__(56);
	
	var _buoyCloseIcon2 = _interopRequireDefault(_buoyCloseIcon);
	
	var _buoyConfig = __webpack_require__(96);
	
	var _brands = __webpack_require__(392);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var BannerParagraph = (0, _styledComponents2.default)(_buoyText.Paragraph).withConfig({
	  displayName: "src__BannerParagraph",
	  componentId: "sc-10fhjbh-0"
	})(_templateObject, (0, _buoyTheme.responsive)("margin-bottom", "0", "0", "24px", "24px", "24px"), (0, _buoyTheme.responsive)("margin-right", "80px", "48px", "0", "0", "0"), _buoyTheme.colors.neutralLightest, _buoyTheme.colors.neutralLight);
	
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: "src__Container",
	  componentId: "sc-10fhjbh-1"
	})(_templateObject2, function (props) {
	  return props.hide && "\n    transition: transform 0.3s ease-out;\n    transform: translateY(100%);\n  ";
	}, function (props) {
	  return props.remove && "display: none;";
	});
	
	var InnerContainer = _styledComponents2.default.div.withConfig({
	  displayName: "src__InnerContainer",
	  componentId: "sc-10fhjbh-2"
	})(_templateObject3, (0, _buoyTheme.responsive)("flex-direction", "row", "row", "column", "column", "column"), (0, _buoyTheme.responsive)("align-items", "center", "center", "flex-end", "flex-end", "flex-end"), function (props) {
	  return props.closeable ? (0, _buoyTheme.responsive)("padding", "26px 150px 26px 60px", "26px 150px 26px 60px", "46px 20px 24px", "46px 20px 24px", "46px 20px 24px") : (0, _buoyTheme.responsive)("padding", "26px 60px", "26px 60px", "24px 20px", "24px 20px", "24px 20px");
	});
	
	var CloseIconWrapper = _styledComponents2.default.div.withConfig({
	  displayName: "src__CloseIconWrapper",
	  componentId: "sc-10fhjbh-3"
	})(_templateObject4, (0, _buoyTheme.responsive)("top", "4px", "4px", "0", "0", "0"), (0, _buoyTheme.responsive)("right", "46px", "46px", "0", "0", "0"));
	
	var BottomBanner = function BottomBanner(_ref) {
	  var onClick = _ref.onClick,
	      children = _ref.children,
	      buttonText = _ref.buttonText,
	      closeable = _ref.closeable,
	      hide = _ref.hide,
	      remove = _ref.remove;
	  return _react2.default.createElement(
	    Container,
	    { closeable: closeable, hide: hide, remove: remove },
	    _react2.default.createElement(
	      InnerContainer,
	      { closeable: closeable },
	      closeable && _react2.default.createElement(
	        CloseIconWrapper,
	        null,
	        _react2.default.createElement(_buoyCloseIcon2.default, {
	          onClick: onClick,
	          hoverColor: "white",
	          color: "neutralLightest"
	        })
	      ),
	      _react2.default.createElement(
	        BannerParagraph,
	        { color: "neutralLightest", small: true },
	        children
	      ),
	      _react2.default.createElement(
	        _buoyButton2.default,
	        { onClick: onClick },
	        buttonText
	      )
	    )
	  );
	};
	
	var Overlay = _styledComponents2.default.div.withConfig({
	  displayName: "src__Overlay",
	  componentId: "sc-10fhjbh-4"
	})(_templateObject5, _buoyTheme.colors.neutralDarkest);
	
	var CookieBannerWrapper = _styledComponents2.default.div.withConfig({
	  displayName: "src__CookieBannerWrapper",
	  componentId: "sc-10fhjbh-5"
	})(_templateObject6);
	
	var CookieBanner = function CookieBanner(props) {
	  return _react2.default.createElement(
	    CookieBannerWrapper,
	    null,
	    props.overlay && _react2.default.createElement(Overlay, null),
	    _react2.default.createElement(
	      BottomBanner,
	      _extends({ buttonText: props.cta }, props),
	      _react2.default.createElement(
	        _buoyRawHtml2.default,
	        null,
	        props.text
	      )
	    )
	  );
	};
	
	var CookieBannerContainer = function (_React$Component) {
	  _inherits(CookieBannerContainer, _React$Component);
	
	  function CookieBannerContainer() {
	    _classCallCheck(this, CookieBannerContainer);
	
	    var _this = _possibleConstructorReturn(this, (CookieBannerContainer.__proto__ || Object.getPrototypeOf(CookieBannerContainer)).call(this));
	
	    _this.componentDidMount = function () {
	      var prod = _this.props.prod === true;
	      var brand = _this.props.brand || (0, _brands.getBrand)(prod);
	      if (brand !== _this.state.brand) {
	        _this.setState({ brand: brand });
	      }
	    };
	
	    _this.onClick = function () {
	      // Hide banner
	      _this.setState({ hide: true });
	      setTimeout(function () {
	        _this.setState({ remove: true }, function () {
	          if (_this.props.onClick) {
	            _this.props.onClick();
	          }
	        });
	      }, 500);
	    };
	
	    _this.state = {
	      brand: null,
	      hide: false,
	      remove: false
	    };
	    return _this;
	  }
	
	  _createClass(CookieBannerContainer, [{
	    key: "render",
	    value: function render() {
	      var brand = this.state.brand;
	
	
	      if (!brand || !(brand in _buoyConfig.gdprConfig)) {
	        brand = "default";
	      }
	
	      var _gdprConfig$brand = _buoyConfig.gdprConfig[brand],
	          text = _gdprConfig$brand.text,
	          cta = _gdprConfig$brand.cta;
	
	
	      return _react2.default.createElement(CookieBanner, _extends({}, this.state, this.props, {
	        cta: cta,
	        text: text,
	        closeable: this.props.closeable,
	        overlay: this.props.overlay && !this.state.hide,
	        onClick: this.onClick
	      }));
	    }
	  }]);
	
	  return CookieBannerContainer;
	}(_react2.default.Component);
	
	exports.default = BottomBanner;
	exports.CookieBannerContainer = CookieBannerContainer;

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBrand = undefined;
	
	var _queryString = __webpack_require__(308);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSubdomain = function getSubdomain() {
	
	  if (typeof window === "undefined" || window.location.href.indexOf("buoyhealth.com") === -1) {
	    return undefined;
	  }
	
	  var subdomain = /:\/\/([^./]+)/.exec(window.location.href);
	  if (subdomain) {
	    subdomain = subdomain[1];
	    // We don't really need to include this anymore, but we'll avoid a lot of
	    // unnecessary calls to the backend resulting in 404s if we keep these sanity
	    // checks for known subdomain lookalikes that aren't supported brands.
	    if (!subdomain || subdomain === "www" || subdomain.startsWith("research") || subdomain.startsWith("sandbox") || subdomain.startsWith("staging")) {
	      return undefined;
	    }
	  }
	  return subdomain;
	};
	
	var getBrand = exports.getBrand = function getBrand() {
	  var prod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	
	  if (typeof window === "undefined") {
	    return undefined;
	  }
	
	  var query = _queryString2.default.parse(window.location.search).brand;
	  var subdomain = getSubdomain();
	
	  // In production, subdomain trumps the query string
	  // In other environments, query string trumps subdomain for testing purposes
	  var brand = void 0;
	  if (prod) {
	    brand = subdomain ? subdomain : query;
	  } else {
	    brand = query ? query : subdomain;
	  }
	
	  return brand;
	};

/***/ }),

/***/ 461:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
	function testPassiveEventListeners() {
	  if (!CAN_USE_DOM) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      // eslint-disable-next-line getter-return
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    var noop = function noop() {};
	    window.addEventListener('testPassiveEventSupport', noop, opts);
	    window.removeEventListener('testPassiveEventSupport', noop, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!canUsePassiveEventListeners()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}
	
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}
	
	function ensureCanMutateNextEventHandlers(eventHandlers) {
	  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
	    // eslint-disable-next-line no-param-reassign
	    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
	  }
	}
	
	function TargetEventHandlers(target) {
	  this.target = target;
	  this.events = {};
	}
	
	TargetEventHandlers.prototype.getEventHandlers = function () {
	  function getEventHandlers(eventName, options) {
	    var key = String(eventName) + ' ' + String(eventOptionsKey(options));
	
	    if (!this.events[key]) {
	      this.events[key] = {
	        handlers: [],
	        handleEvent: undefined
	      };
	      this.events[key].nextHandlers = this.events[key].handlers;
	    }
	
	    return this.events[key];
	  }
	
	  return getEventHandlers;
	}();
	
	TargetEventHandlers.prototype.handleEvent = function () {
	  function handleEvent(eventName, options, event) {
	    var eventHandlers = this.getEventHandlers(eventName, options);
	    eventHandlers.handlers = eventHandlers.nextHandlers;
	    eventHandlers.handlers.forEach(function (handler) {
	      if (handler) {
	        // We need to check for presence here because a handler function may
	        // cause later handlers to get removed. This can happen if you for
	        // instance have a waypoint that unmounts another waypoint as part of an
	        // onEnter/onLeave handler.
	        handler(event);
	      }
	    });
	  }
	
	  return handleEvent;
	}();
	
	TargetEventHandlers.prototype.add = function () {
	  function add(eventName, listener, options) {
	    var _this = this;
	
	    // options has already been normalized at this point.
	    var eventHandlers = this.getEventHandlers(eventName, options);
	
	    ensureCanMutateNextEventHandlers(eventHandlers);
	
	    if (eventHandlers.nextHandlers.length === 0) {
	      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	    }
	
	    eventHandlers.nextHandlers.push(listener);
	
	    var isSubscribed = true;
	    var unsubscribe = function () {
	      function unsubscribe() {
	        if (!isSubscribed) {
	          return;
	        }
	
	        isSubscribed = false;
	
	        ensureCanMutateNextEventHandlers(eventHandlers);
	        var index = eventHandlers.nextHandlers.indexOf(listener);
	        eventHandlers.nextHandlers.splice(index, 1);
	
	        if (eventHandlers.nextHandlers.length === 0) {
	          // All event handlers have been removed, so we want to remove the event
	          // listener from the target node.
	
	          if (_this.target) {
	            // There can be a race condition where the target may no longer exist
	            // when this function is called, e.g. when a React component is
	            // unmounting. Guarding against this prevents the following error:
	            //
	            //   Cannot read property 'removeEventListener' of undefined
	            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	          }
	
	          eventHandlers.handleEvent = undefined;
	        }
	      }
	
	      return unsubscribe;
	    }();
	    return unsubscribe;
	  }
	
	  return add;
	}();
	
	var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	// eslint-disable-next-line import/prefer-default-export
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
	  }
	  var normalizedEventOptions = normalizeEventOptions(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	exports.addEventListener = addEventListener;


/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var consolidatedEvents = __webpack_require__(461);
	var PropTypes = _interopDefault(__webpack_require__(5));
	var reactIs = __webpack_require__(312);
	
	/**
	 * Attempts to parse the offset provided as a prop as a percentage. For
	 * instance, if the component has been provided with the string "20%" as
	 * a value of one of the offset props. If the value matches, then it returns
	 * a numeric version of the prop. For instance, "20%" would become `0.2`.
	 * If `str` isn't a percentage, then `undefined` will be returned.
	 *
	 * @param {string} str The value of an offset prop to be converted to a
	 *   number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was not a percentage.
	 */
	function parseOffsetAsPercentage(str) {
	  if (str.slice(-1) === '%') {
	    return parseFloat(str.slice(0, -1)) / 100;
	  }
	}
	
	/**
	 * Attempts to parse the offset provided as a prop as a pixel value. If
	 * parsing fails, then `undefined` is returned. Three examples of values that
	 * will be successfully parsed are:
	 * `20`
	 * "20px"
	 * "20"
	 *
	 * @param {string|number} str A string of the form "{number}" or "{number}px",
	 *   or just a number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was neither a number nor string ending in "px".
	 */
	function parseOffsetAsPixels(str) {
	  if (!isNaN(parseFloat(str)) && isFinite(str)) {
	    return parseFloat(str);
	  } else if (str.slice(-2) === 'px') {
	    return parseFloat(str.slice(0, -2));
	  }
	}
	
	/**
	 * @param {string|number} offset
	 * @param {number} contextHeight
	 * @return {number} A number representing `offset` converted into pixels.
	 */
	function computeOffsetPixels(offset, contextHeight) {
	  var pixelOffset = parseOffsetAsPixels(offset);
	
	  if (typeof pixelOffset === 'number') {
	    return pixelOffset;
	  }
	
	  var percentOffset = parseOffsetAsPercentage(offset);
	  if (typeof percentOffset === 'number') {
	    return percentOffset * contextHeight;
	  }
	}
	
	var constants = {
	  above: 'above',
	  inside: 'inside',
	  below: 'below',
	  invisible: 'invisible'
	};
	
	function debugLog() {
	  if (false) {
	    console.log(arguments); // eslint-disable-line no-console
	  }
	}
	
	var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
	
	/**
	 * Raise an error if more that one child was provided to "children"
	 *
	 * @param {?React.element} children
	 * @return {undefined}
	 */
	function ensureChildrenIsValid(children) {
	  if (children) {
	    try {
	      React.Children.only(children);
	    } catch (e) {
	      throw new Error(errorMessage);
	    }
	  }
	}
	
	/**
	 * When an element's type is a string, it represents a DOM node with that tag name
	 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
	 *
	 * @param {React.element} Component
	 * @return {bool} Whether the component is a DOM Element
	 */
	function isDOMElement(Component) {
	  return typeof Component.type === 'string';
	}
	
	var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
	
	/**
	 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
	 *
	 * @param {?React.element} children
	 * @param {?HTMLElement} ref
	 * @return {undefined}
	 */
	function ensureRefIsProvidedByChild(children, ref) {
	  if (children && !isDOMElement(children) && !ref) {
	    throw new Error(errorMessage$1);
	  }
	}
	
	/**
	 * @param {object} bounds An object with bounds data for the waypoint and
	 *   scrollable parent
	 * @return {string} The current position of the waypoint in relation to the
	 *   visible portion of the scrollable parent. One of `constants.above`,
	 *   `constants.below`, or `constants.inside`.
	 */
	function getCurrentPosition(bounds) {
	  if (bounds.viewportBottom - bounds.viewportTop === 0) {
	    return constants.invisible;
	  }
	
	  // top is within the viewport
	  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
	    return constants.inside;
	  }
	
	  // bottom is within the viewport
	  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
	    return constants.inside;
	  }
	
	  // top is above the viewport and bottom is below the viewport
	  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
	    return constants.inside;
	  }
	
	  if (bounds.viewportBottom < bounds.waypointTop) {
	    return constants.below;
	  }
	
	  if (bounds.waypointTop < bounds.viewportTop) {
	    return constants.above;
	  }
	
	  return constants.invisible;
	}
	
	var timeout = void 0;
	var timeoutQueue = [];
	
	function onNextTick(cb) {
	  timeoutQueue.push(cb);
	
	  if (!timeout) {
	    timeout = setTimeout(function () {
	      timeout = null;
	
	      // Drain the timeoutQueue
	      var item = void 0;
	      // eslint-disable-next-line no-cond-assign
	      while (item = timeoutQueue.shift()) {
	        item();
	      }
	    }, 0);
	  }
	
	  var isSubscribed = true;
	
	  return function () {
	    function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      var index = timeoutQueue.indexOf(cb);
	      if (index === -1) {
	        return;
	      }
	
	      timeoutQueue.splice(index, 1);
	
	      if (!timeoutQueue.length && timeout) {
	        clearTimeout(timeout);
	        timeout = null;
	      }
	    }
	
	    return unsubscribe;
	  }();
	}
	
	function resolveScrollableAncestorProp(scrollableAncestor) {
	  // When Waypoint is rendered on the server, `window` is not available.
	  // To make Waypoint easier to work with, we allow this to be specified in
	  // string form and safely convert to `window` here.
	  if (scrollableAncestor === 'window') {
	    return global.window;
	  }
	
	  return scrollableAncestor;
	}
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultProps = {
	  topOffset: '0px',
	  bottomOffset: '0px',
	  horizontal: false,
	  onEnter: function () {
	    function onEnter() {}
	
	    return onEnter;
	  }(),
	  onLeave: function () {
	    function onLeave() {}
	
	    return onLeave;
	  }(),
	  onPositionChange: function () {
	    function onPositionChange() {}
	
	    return onPositionChange;
	  }(),
	
	  fireOnRapidScroll: true
	};
	
	// React.PureComponent was added in React 15.3.0
	var BaseClass = typeof React.PureComponent !== 'undefined' ? React.PureComponent : React.Component;
	
	// Calls a function when you scroll to the element.
	
	var Waypoint = function (_BaseClass) {
	  _inherits(Waypoint, _BaseClass);
	
	  function Waypoint(props) {
	    _classCallCheck(this, Waypoint);
	
	    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));
	
	    _this.refElement = function (e) {
	      return _this._ref = e;
	    };
	    return _this;
	  }
	
	  _createClass(Waypoint, [{
	    key: 'componentWillMount',
	    value: function () {
	      function componentWillMount() {
	        ensureChildrenIsValid(this.props.children);
	      }
	
	      return componentWillMount;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _this2 = this;
	
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        // this._ref may occasionally not be set at this time. To help ensure that
	        // this works smoothly and to avoid layout thrashing, we want to delay the
	        // initial execution until the next tick.
	        this.cancelOnNextTick = onNextTick(function () {
	          _this2.cancelOnNextTick = null;
	
	          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
	          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);
	
	          _this2._handleScroll = _this2._handleScroll.bind(_this2);
	          _this2.scrollableAncestor = _this2._findScrollableAncestor();
	
	          if (false) {
	            debugLog('scrollableAncestor', _this2.scrollableAncestor);
	          }
	
	          _this2.scrollEventListenerUnsubscribe = consolidatedEvents.addEventListener(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });
	
	          _this2.resizeEventListenerUnsubscribe = consolidatedEvents.addEventListener(window, 'resize', _this2._handleScroll, { passive: true });
	
	          _this2._handleScroll(null);
	        });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(newProps) {
	        ensureChildrenIsValid(newProps.children);
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate() {
	        var _this3 = this;
	
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        if (!this.scrollableAncestor) {
	          // The Waypoint has not yet initialized.
	          return;
	        }
	
	        // The element may have moved, so we need to recompute its position on the
	        // page. This happens via handleScroll in a way that forces layout to be
	        // computed.
	        //
	        // We want this to be deferred to avoid forcing layout during render, which
	        // causes layout thrashing. And, if we already have this work enqueued, we
	        // can just wait for that to happen instead of enqueueing again.
	        if (this.cancelOnNextTick) {
	          return;
	        }
	
	        this.cancelOnNextTick = onNextTick(function () {
	          _this3.cancelOnNextTick = null;
	          _this3._handleScroll(null);
	        });
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        if (this.scrollEventListenerUnsubscribe) {
	          this.scrollEventListenerUnsubscribe();
	        }
	        if (this.resizeEventListenerUnsubscribe) {
	          this.resizeEventListenerUnsubscribe();
	        }
	
	        if (this.cancelOnNextTick) {
	          this.cancelOnNextTick();
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	
	    /**
	     * Traverses up the DOM to find an ancestor container which has an overflow
	     * style that allows for scrolling.
	     *
	     * @return {Object} the closest ancestor element with an overflow style that
	     *   allows for scrolling. If none is found, the `window` object is returned
	     *   as a fallback.
	     */
	
	  }, {
	    key: '_findScrollableAncestor',
	    value: function () {
	      function _findScrollableAncestor() {
	        var _props = this.props,
	            horizontal = _props.horizontal,
	            scrollableAncestor = _props.scrollableAncestor;
	
	
	        if (scrollableAncestor) {
	          return resolveScrollableAncestorProp(scrollableAncestor);
	        }
	
	        var node = this._ref;
	
	        while (node.parentNode) {
	          node = node.parentNode;
	
	          if (node === document.body) {
	            // We've reached all the way to the root node.
	            return window;
	          }
	
	          var style = window.getComputedStyle(node);
	          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
	          var overflow = overflowDirec || style.getPropertyValue('overflow');
	
	          if (overflow === 'auto' || overflow === 'scroll') {
	            return node;
	          }
	        }
	
	        // A scrollable ancestor element was not found, which means that we need to
	        // do stuff on window.
	        return window;
	      }
	
	      return _findScrollableAncestor;
	    }()
	
	    /**
	     * @param {Object} event the native scroll event coming from the scrollable
	     *   ancestor, or resize event coming from the window. Will be undefined if
	     *   called by a React lifecyle method
	     */
	
	  }, {
	    key: '_handleScroll',
	    value: function () {
	      function _handleScroll(event) {
	        if (!this._ref) {
	          // There's a chance we end up here after the component has been unmounted.
	          return;
	        }
	
	        var bounds = this._getBounds();
	        var currentPosition = getCurrentPosition(bounds);
	        var previousPosition = this._previousPosition;
	
	        if (false) {
	          debugLog('currentPosition', currentPosition);
	          debugLog('previousPosition', previousPosition);
	        }
	
	        // Save previous position as early as possible to prevent cycles
	        this._previousPosition = currentPosition;
	
	        if (previousPosition === currentPosition) {
	          // No change since last trigger
	          return;
	        }
	
	        var callbackArg = {
	          currentPosition: currentPosition,
	          previousPosition: previousPosition,
	          event: event,
	          waypointTop: bounds.waypointTop,
	          waypointBottom: bounds.waypointBottom,
	          viewportTop: bounds.viewportTop,
	          viewportBottom: bounds.viewportBottom
	        };
	        this.props.onPositionChange.call(this, callbackArg);
	
	        if (currentPosition === constants.inside) {
	          this.props.onEnter.call(this, callbackArg);
	        } else if (previousPosition === constants.inside) {
	          this.props.onLeave.call(this, callbackArg);
	        }
	
	        var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
	        var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;
	
	        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
	          // If the scroll event isn't fired often enough to occur while the
	          // waypoint was visible, we trigger both callbacks anyway.
	          this.props.onEnter.call(this, {
	            currentPosition: constants.inside,
	            previousPosition: previousPosition,
	            event: event,
	            waypointTop: bounds.waypointTop,
	            waypointBottom: bounds.waypointBottom,
	            viewportTop: bounds.viewportTop,
	            viewportBottom: bounds.viewportBottom
	          });
	          this.props.onLeave.call(this, {
	            currentPosition: currentPosition,
	            previousPosition: constants.inside,
	            event: event,
	            waypointTop: bounds.waypointTop,
	            waypointBottom: bounds.waypointBottom,
	            viewportTop: bounds.viewportTop,
	            viewportBottom: bounds.viewportBottom
	          });
	        }
	      }
	
	      return _handleScroll;
	    }()
	  }, {
	    key: '_getBounds',
	    value: function () {
	      function _getBounds() {
	        var horizontal = this.props.horizontal;
	
	        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
	            left = _ref$getBoundingClien.left,
	            top = _ref$getBoundingClien.top,
	            right = _ref$getBoundingClien.right,
	            bottom = _ref$getBoundingClien.bottom;
	
	        var waypointTop = horizontal ? left : top;
	        var waypointBottom = horizontal ? right : bottom;
	
	        var contextHeight = void 0;
	        var contextScrollTop = void 0;
	        if (this.scrollableAncestor === window) {
	          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
	          contextScrollTop = 0;
	        } else {
	          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
	          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
	        }
	
	        if (false) {
	          debugLog('waypoint top', waypointTop);
	          debugLog('waypoint bottom', waypointBottom);
	          debugLog('scrollableAncestor height', contextHeight);
	          debugLog('scrollableAncestor scrollTop', contextScrollTop);
	        }
	
	        var _props2 = this.props,
	            bottomOffset = _props2.bottomOffset,
	            topOffset = _props2.topOffset;
	
	        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
	        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
	        var contextBottom = contextScrollTop + contextHeight;
	
	        return {
	          waypointTop: waypointTop,
	          waypointBottom: waypointBottom,
	          viewportTop: contextScrollTop + topOffsetPx,
	          viewportBottom: contextBottom - bottomOffsetPx
	        };
	      }
	
	      return _getBounds;
	    }()
	
	    /**
	     * @return {Object}
	     */
	
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this4 = this;
	
	        var children = this.props.children;
	
	
	        if (!children) {
	          // We need an element that we can locate in the DOM to determine where it is
	          // rendered relative to the top of its context.
	          return React.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
	        }
	
	        if (isDOMElement(children) || reactIs.isForwardRef(children.type)) {
	          var ref = function () {
	            function ref(node) {
	              _this4.refElement(node);
	              if (children.ref) {
	                if (typeof children.ref === 'function') {
	                  children.ref(node);
	                } else {
	                  children.ref.current = node;
	                }
	              }
	            }
	
	            return ref;
	          }();
	
	          return React.cloneElement(children, { ref: ref });
	        }
	
	        return React.cloneElement(children, { innerRef: this.refElement });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return Waypoint;
	}(BaseClass);
	
	
	Waypoint.propTypes = {
	  children: PropTypes.node,
	  debug: PropTypes.bool,
	  onEnter: PropTypes.func,
	  onLeave: PropTypes.func,
	  onPositionChange: PropTypes.func,
	  fireOnRapidScroll: PropTypes.bool,
	  scrollableAncestor: PropTypes.any,
	  horizontal: PropTypes.bool,
	
	  // `topOffset` can either be a number, in which case its a distance from the
	  // top of the container in pixels, or a string value. Valid string values are
	  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
	  // as a percentage of the height of the containing element.
	  // For instance, if you pass "-20%", and the containing element is 100px tall,
	  // then the waypoint will be triggered when it has been scrolled 20px beyond
	  // the top of the containing element.
	  topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	
	  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
	  bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	
	Waypoint.above = constants.above;
	Waypoint.below = constants.below;
	Waypoint.inside = constants.inside;
	Waypoint.invisible = constants.invisible;
	Waypoint.getWindow = function () {
	  if (typeof window !== 'undefined') {
	    return window;
	  }
	};
	Waypoint.defaultProps = defaultProps;
	Waypoint.displayName = 'Waypoint';
	
	module.exports = Waypoint;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  background-repeat: no-repeat;\n  text-align: center;\n  ", "\n  ", "\n  ", "\n"], ["\n  ", ";\n  background-repeat: no-repeat;\n  text-align: center;\n  ", "\n  ", "\n  ", "\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _buoyTheme = __webpack_require__(4);
	
	var _Section = __webpack_require__(76);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _buoyCore = __webpack_require__(17);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _responsive = __webpack_require__(16);
	
	var _responsive2 = _interopRequireDefault(_responsive);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var AboutSection = (0, _styledComponents2.default)(_Section2.default)(_templateObject, (0, _responsive2.default)("padding-bottom", "110px", "52ch", "50ch", "40ch"), function (props) {
	  return (0, _responsive2.default)('background-image', "url(" + props.image.xl + ")", "url(" + props.image.lg + ")", "url(" + props.image.md + ")", "url(" + props.image.sm + ")");
	}, (0, _responsive2.default)("background-size", "auto 50ch", "auto 50ch", "auto 50ch", "auto 40ch"), (0, _responsive2.default)("background-position", "56% center", "30% 98%", "15% 98%", "20% 98%"));
	
	var About = function About(_ref) {
	  var headline = _ref.headline,
	      image = _ref.image,
	      body = _ref.body,
	      button = _ref.button,
	      symptomCheckerPath = _ref.symptomCheckerPath;
	  return _react2.default.createElement(
	    AboutSection,
	    { image: image },
	    _react2.default.createElement(
	      _buoyCore.HeadingTwo,
	      null,
	      headline
	    ),
	    _react2.default.createElement(
	      _buoyCore.Paragraph,
	      { maxWidth: "500px", margin: "0 0 40px", center: true },
	      body
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { large: true, arrow: true, href: (0, _utils.generatePageUrl)(symptomCheckerPath) },
	      button
	    )
	  );
	};
	
	var AboutContainer = function (_React$Component) {
	  _inherits(AboutContainer, _React$Component);
	
	  function AboutContainer(props) {
	    _classCallCheck(this, AboutContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var imgSrc = (0, _utils.getImageUrl)(props.image + "?auto=format,compress&crop=fit&px=16&blur=200");
	
	    _this.state = {
	      image: {
	        sm: imgSrc + "&h=720",
	        md: imgSrc + "&h=900",
	        lg: imgSrc + "&h=934",
	        xl: imgSrc + "&h=940"
	      }
	    };
	    return _this;
	  }
	
	  AboutContainer.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var hdImage = new Image();
	    var imgSrc = (0, _utils.getImageUrl)(this.props.image + "?auto=format,compress&crop=fit");
	    var newState = { image: {} };
	    var screenWidth = window.innerWidth;
	
	    if (screenWidth <= _buoyTheme.breakpoints.sm) {
	      hdImage.src = imgSrc + "&h=720";
	      newState = {
	        image: {
	          sm: hdImage.src,
	          md: imgSrc + "&h=900",
	          lg: imgSrc + "&h=934",
	          xl: imgSrc + "&h=940"
	        }
	      };
	    } else if (screenWidth <= _buoyTheme.breakpoints.md) {
	      hdImage.src = imgSrc + "&h=900";
	      newState = {
	        image: {
	          sm: hdImage.src,
	          md: hdImage.src,
	          lg: imgSrc + "&h=934",
	          xl: imgSrc + "&h=940"
	        }
	      };
	    } else if (screenWidth <= _buoyTheme.breakpoints.lg) {
	      hdImage.src = imgSrc + "&h=934";
	      newState = {
	        image: {
	          sm: hdImage.src,
	          md: hdImage.src,
	          lg: hdImage.src,
	          xl: imgSrc + "&h=940"
	        }
	      };
	    } else {
	      hdImage.src = imgSrc + "&h=940";
	      newState = {
	        image: {
	          sm: hdImage.src,
	          md: hdImage.src,
	          lg: hdImage.src,
	          xl: hdImage.src
	        }
	      };
	    }
	
	    hdImage.onload = function () {
	      _this2.setState(newState);
	    };
	  };
	
	  AboutContainer.prototype.render = function render() {
	    return _react2.default.createElement(About, _extends({}, this.props, this.state));
	  };
	
	  return AboutContainer;
	}(_react2.default.Component);
	
	exports.default = AboutContainer;
	module.exports = exports["default"];

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTQgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjEgKDUxMTQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5JY29uIDogYXJyb3ctcmlnaHQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iMTgwNDE4IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSIxX0hQLUQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02OTMuMDAwMDAwLCAtMjY0MS4wMDAwMDApIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMS4yNSI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC0yMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTQzLjAwMDAwMCwgMjYyNS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC0xNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjguMDAwMDAwLCAxMS4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iSWNvbi06LWFycm93LXJpZ2h0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjkuNTAwMDAwLCAxMS4wMDAwMDApIHNjYWxlKC0xLCAxKSByb3RhdGUoLTE4MC4wMDAwMDApIHRyYW5zbGF0ZSgtMTI5LjUwMDAwMCwgLTExLjAwMDAwMCkgdHJhbnNsYXRlKDEyMy4wMDAwMDAsIDYuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJTdHJva2UtNTIiIHBvaW50cz0iMTIuMzE5MTc0NSA0Ljk1NDE2NjgxIDcuMzM4NTg1NDkgLTQuOTczNzk5MTVlLTE1Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLjQzMzMzMzMzMyw0Ljk1NDE2NjgxIEwxMS44MzkyMDg2LDQuOTU0MTY2ODEiIGlkPSJTdHJva2UtNTQiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTEyLjMxOTE3NDUsNC45NTQxNjY4MSBMNy4zMzg1ODU0OSw5LjkwODMzMzYyIiBpZD0iU3Ryb2tlLTU2Ij48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  font-weight: ", ";\n  text-decoration: none;\n  text-align: center;\n  color: ", ";\n  background-color: ", ";\n  ", " letter-spacing: 0.2px;\n  border-radius: 2px;\n  min-width: ", ";\n  padding: ", ";\n  cursor: ", ";\n  border: solid 1px ", ";\n  transition: all 300ms ease;\n\n  ", " &:hover {\n    background-color: ", ";\n    border: solid 1px ", ";\n    color: ", ";\n    img {\n      transform: translateX(4px);\n    }\n  }\n"], ["\n  ", ";\n  font-weight: ", ";\n  text-decoration: none;\n  text-align: center;\n  color: ", ";\n  background-color: ", ";\n  ", " letter-spacing: 0.2px;\n  border-radius: 2px;\n  min-width: ", ";\n  padding: ", ";\n  cursor: ", ";\n  border: solid 1px ", ";\n  transition: all 300ms ease;\n\n  ", " &:hover {\n    background-color: ", ";\n    border: solid 1px ", ";\n    color: ", ";\n    img {\n      transform: translateX(4px);\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin-left: 10px;\n  transition: transform 0.5s;\n"], ["\n  margin-left: 10px;\n  transition: transform 0.5s;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _buoyTheme = __webpack_require__(4);
	
	var _arrow = __webpack_require__(208);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _style = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ButtonContainer = _styledComponents2.default.a.attrs({
	  role: "button"
	})(_templateObject, (0, _buoyTheme.fontSize)("bodyMain"), function (props) {
	  return props.large ? _buoyTheme.fontWeight.medium(props) : _buoyTheme.fontWeight.regular(props);
	}, _style.textColor, _style.backgroundColor, function (props) {
	  return props.display ? "display: " + props.display + ";" : "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  ";
	}, function (props) {
	  return props.large ? "210px" : "128px";
	}, function (props) {
	  return props.large ? "15px 24px 17px" : "7px 20px 9px";
	}, function (props) {
	  return props.disabled ? "not-allowed" : "pointer";
	}, _style.borderColor, function (props) {
	  return props.border && "border: solid 1px " + props.theme.colors[props.color] + ";";
	}, _style.hoverColor, _style.hoverBorderColor, _style.hoverTextColor);
	
	var ButtonArrow = _styledComponents2.default.img(_templateObject2);
	
	var Button = function Button(props) {
	  return _react2.default.createElement(
	    ButtonContainer,
	    props,
	    props.children,
	    props.arrow && _react2.default.createElement(ButtonArrow, { src: _arrow2.default })
	  );
	};
	
	exports.default = Button;
	module.exports = exports["default"];

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var backgroundColor = exports.backgroundColor = function backgroundColor(props) {
	  var color = props.color || "primary";
	  if (props.ghost) {
	    color = "transparent";
	  }
	
	  if (props.disabled && (props.color === "primary" || props.color === "landingRed" || props.color === "landingBlue")) {
	    color = props.color + "Light";
	  }
	
	  return props.theme.colors[color];
	};
	
	var hoverColor = exports.hoverColor = function hoverColor(props) {
	  var color = props.hoverColor || "primaryDark";
	  if (props.ghost) {
	    color = props.color || "primary";
	  } else if (props.color === "landingRed") {
	    color = "landingRedDark";
	  } else if (props.color === "landingBlue") {
	    color = "landingBlueDark";
	  }
	
	  if (props.disabled && (props.color === "primary" || props.color === "landingRed" || props.color === "landingBlue")) {
	    color = props.color + "Light";
	  }
	
	  return props.theme.colors[color];
	};
	
	var textColor = exports.textColor = function textColor(props) {
	  var color = props.textColor || "white";
	  if (props.ghost) {
	    color = props.color;
	  }
	  return props.theme.colors[color];
	};
	
	var hoverTextColor = exports.hoverTextColor = function hoverTextColor(props) {
	  var color = props.hoverTextColor || "white";
	  return props.theme.colors[color];
	};
	
	var borderColor = exports.borderColor = function borderColor(props) {
	  var color = props.borderColor || props.color || "primary";
	
	  if (props.disabled && (props.color === "primary" || props.color === "landingRed" || props.color === "landingBlue")) {
	    color = props.color + "Light";
	  }
	
	  return props.theme.colors[color];
	};
	
	var hoverBorderColor = exports.hoverBorderColor = hoverColor;

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background: ", ";\n  box-shadow: ", ";\n  border-top: ", ";\n  height: 100%;\n  width: 100%;\n  margin: 0 auto;\n  ", "\n  ", "\n"], ["\n  position: relative;\n  background: ", ";\n  box-shadow: ", ";\n  border-top: ", ";\n  height: 100%;\n  width: 100%;\n  margin: 0 auto;\n  ", "\n  ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-size: 26px;\n  line-height: 1.3;\n  color: ", ";\n  margin: 0 0 4px 0;\n  font-weight: ", ";\n  text-align: center;\n"], ["\n  font-size: 26px;\n  line-height: 1.3;\n  color: ", ";\n  margin: 0 0 4px 0;\n  font-weight: ", ";\n  text-align: center;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  ", ";\n  font-weight: ", ";\n  margin: 0;\n"], ["\n  color: ", ";\n  ", ";\n  font-weight: ", ";\n  margin: 0;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  margin: 16px 0;\n"], ["\n  margin: 16px 0;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  width: 55px;\n  height: 65px;\n  margin: 0 auto;\n  display: block;\n  ", "\n"], ["\n  width: 55px;\n  height: 65px;\n  margin: 0 auto;\n  display: block;\n  ", "\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"], ["\n  text-align: center;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  padding-top: 0px;\n"], ["\n  padding-top: 0px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _buoyTheme = __webpack_require__(4);
	
	var _buoyCore = __webpack_require__(17);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CardContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.backgroundColor || _buoyTheme.colors.white(props);
	}, function (props) {
	  return props.boxShadow || "0 0 8px 0 rgba(0,0,0,0.08)";
	}, function (props) {
	  return props.borderTop || "2px solid " + (props.theme.colors[props.color] || _buoyTheme.colors.black(props));
	}, (0, _buoyTheme.responsive)("max-width", "690px", "690px", "690px", "390px"), function (props) {
	  return props.padding ? "padding: " + props.padding + ";" : (0, _buoyTheme.responsive)("padding", "24px 88px 44px 88px", "24px 88px 44px 88px", "24px 88px 44px 88px", "16px 16px 36px 16px");
	});
	
	var CardTitle = _styledComponents2.default.h3(_templateObject2, function (props) {
	  return props.theme.colors[props.color];
	}, _buoyTheme.fontWeight.regular);
	
	var CardSubtitle = _styledComponents2.default.h5(_templateObject3, function (props) {
	  return props.theme.colors[props.color];
	}, (0, _buoyTheme.fontSize)("bodyMain"), _buoyTheme.fontWeight.regular);
	
	var CardCopy = (0, _styledComponents2.default)(_buoyCore.Paragraph).attrs({ small: true })(_templateObject4);
	
	var CardImage = _styledComponents2.default.img(_templateObject5, function (props) {
	  return !props.productPage && "margin-bottom: 10px;";
	});
	
	var CardTitleWrapper = _styledComponents2.default.div(_templateObject6);
	
	var CardContent = _styledComponents2.default.div(_templateObject6);
	
	var ChildrenWrapper = _styledComponents2.default.div(_templateObject7);
	
	var Card = function Card(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      copy = _ref.copy,
	      color = _ref.color,
	      image = _ref.image,
	      buttonText = _ref.buttonText,
	      url = _ref.url,
	      backgroundColor = _ref.backgroundColor,
	      boxShadow = _ref.boxShadow,
	      borderTop = _ref.borderTop,
	      padding = _ref.padding,
	      children = _ref.children,
	      productPage = _ref.productPage;
	  return _react2.default.createElement(
	    CardContainer,
	    {
	      color: color,
	      backgroundColor: backgroundColor,
	      boxShadow: boxShadow,
	      borderTop: borderTop,
	      padding: padding
	    },
	    image && _react2.default.createElement(CardImage, { productPage: productPage, src: image.src, alt: image.alt }),
	    _react2.default.createElement(
	      CardTitleWrapper,
	      { productPage: productPage },
	      _react2.default.createElement(
	        CardTitle,
	        { color: color },
	        title
	      ),
	      _react2.default.createElement(
	        CardSubtitle,
	        { color: color },
	        subtitle
	      )
	    ),
	    _react2.default.createElement(
	      CardContent,
	      null,
	      copy && _react2.default.createElement(
	        CardCopy,
	        null,
	        copy
	      ),
	      buttonText && _react2.default.createElement(
	        _Button2.default,
	        {
	          href: (0, _utils.generatePageUrl)(url),
	          color: color,
	          display: "inline-block",
	          padding: "10px 50px",
	          ghost: true,
	          margin: "16px 0"
	        },
	        buttonText
	      ),
	      children && _react2.default.createElement(
	        ChildrenWrapper,
	        null,
	        children
	      )
	    )
	  );
	};
	
	exports.default = Card;
	module.exports = exports["default"];

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 110px 0 0 0;\n  text-align: center;\n  ", ";\n"], ["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 110px 0 0 0;\n  text-align: center;\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  position: relative;\n"], ["\n  ", ";\n  ", ";\n  position: relative;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  z-index: 2;\n  display: flex;\n  position: relative;\n  margin: 0 auto;\n  ", ";\n  ", ";\n"], ["\n  z-index: 2;\n  display: flex;\n  position: relative;\n  margin: 0 auto;\n  ", ";\n  ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  background-image: radial-gradient(", " 20%, transparent 16%);\n  background-size: 11px 11px;\n  ", "\n"], ["\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  background-image: radial-gradient(", " 20%, transparent 16%);\n  background-size: 11px 11px;\n  ", "\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  ", " ", "\n\n  &:first-child {\n    ", ";\n  }\n\n  &:last-child {\n    ", ";\n  }\n"], ["\n  position: relative;\n  ", " ", "\n\n  &:first-child {\n    ", ";\n  }\n\n  &:last-child {\n    ", ";\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  ", ";\n"], ["\n  text-align: center;\n  ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  margin: 15px 20px;\n"], ["\n  margin: 15px 20px;\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  ", ";\n"], ["\n  ", ";\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _buoyCore = __webpack_require__(17);
	
	var _responsive = __webpack_require__(16);
	
	var _responsive2 = _interopRequireDefault(_responsive);
	
	var _buoyTheme = __webpack_require__(4);
	
	var _Card = __webpack_require__(143);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Label = __webpack_require__(219);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Partner = __webpack_require__(370);
	
	var _Partner2 = _interopRequireDefault(_Partner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var EnterpriseSection = _styledComponents2.default.section(_templateObject, _buoyTheme.colors.white, (0, _responsive2.default)("padding", "110px 0 0", "110px 0 0", "64px 20px 0", "64px 20px 0"));
	
	var CardsContainer = _styledComponents2.default.div(_templateObject2, (0, _responsive2.default)("width", "100%", "100%", "auto"), (0, _responsive2.default)("margin", "20px auto 58px auto", "20px auto 58px auto", "20px auto 0", "20px auto 0"));
	
	var Cards = _styledComponents2.default.div(_templateObject3, (0, _responsive2.default)("flex-direction", "row", "row", "column", "column"), (0, _responsive2.default)("max-width", "950px", "950px", "none", "none"));
	
	var Dots = _styledComponents2.default.div(_templateObject4, (0, _responsive2.default)("width", "56px", "56px", "11px", "11px"), (0, _responsive2.default)("right", "-63px", "-63px", "200px", "140px"), (0, _responsive2.default)("top", "50%", "50%", "103.5%", "101.5%"), (0, _responsive2.default)("height", "20px", "20px", "15%", "15%"), _buoyTheme.colors.neutralLight, (0, _responsive2.default)("background-repeat", "repeat-x", "repeat-x", "repeat-y", "repeat-y"));
	
	var CardColumn = _styledComponents2.default.div(_templateObject5, (0, _responsive2.default)("flex", "1", "1", "0 1 auto"), function (props) {
	  return (0, _responsive2.default)("margin-bottom", "0", "0", props.right ? "78px" : "55px", props.right ? "78px" : "55px");
	}, (0, _responsive2.default)("margin-right", "35px", "35px", "0", "0"), (0, _responsive2.default)("margin-left", "35px", "35px", "0", "0"));
	
	var Trust = _styledComponents2.default.div(_templateObject6, (0, _responsive2.default)("margin-bottom", "110px", "110px", "80px", "64px"));
	
	var Brands = _styledComponents2.default.div(_templateObject7);
	var BrandImageWrapper = _styledComponents2.default.div(_templateObject8);
	
	var Heading = (0, _styledComponents2.default)(_buoyCore.HeadingTwo)(_templateObject9, (0, _responsive2.default)("margin", "0 0 48px 0", "0 0 48px 0", "0 0 24px 0"));
	
	var Enterprise = function Enterprise(_ref) {
	  var headline = _ref.headline,
	      label = _ref.label,
	      partners = _ref.partners,
	      cta = _ref.cta,
	      theme = _ref.theme,
	      products = _ref.products;
	  return _react2.default.createElement(
	    EnterpriseSection,
	    { id: "solutions" },
	    _react2.default.createElement(
	      _Label2.default,
	      null,
	      "Employers"
	    ),
	    _react2.default.createElement(
	      Heading,
	      null,
	      headline
	    ),
	    _react2.default.createElement(
	      CardsContainer,
	      null,
	      _react2.default.createElement(
	        Cards,
	        null,
	        products.map(function (p, index) {
	          var product = p.node;
	          if (product.copy && product.detailList.length > 0) {
	            return _react2.default.createElement(
	              CardColumn,
	              { right: !index, key: index },
	              _react2.default.createElement(_Card2.default, {
	                right: !index,
	                title: product.title,
	                subtitle: product.subtitle,
	                copy: product.copy,
	                color: product.color,
	                boxShadow: _buoyTheme.constants.boxShadow,
	                buttonText: "Request a demo",
	                image: product.image,
	                url: product.page_url
	              })
	            );
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      Trust,
	      null,
	      _react2.default.createElement(
	        _Label2.default,
	        null,
	        label
	      ),
	      _react2.default.createElement(
	        Brands,
	        null,
	        partners.map(function (partner, index) {
	          return _react2.default.createElement(
	            BrandImageWrapper,
	            { key: index },
	            _react2.default.createElement(
	              _responsive.LazyResImage,
	              { src: partner.logo },
	              _react2.default.createElement("img", null)
	            )
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(_Partner2.default, cta)
	  );
	};
	
	exports.default = Enterprise;
	module.exports = exports["default"];

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  ", " align-items: center;\n  ", " width: 100%;\n  z-index: 1;\n"], ["\n  position: relative;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  ", " align-items: center;\n  ", " width: 100%;\n  z-index: 1;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  width: 100vw;\n  left: 0;\n  ", "\n  overflow-x: hidden;\n  ", "\n  background-repeat: no-repeat;\n  ", "\n  ", "\n  ", "\n  z-index: -1;\n"], ["\n  position: absolute;\n  width: 100vw;\n  left: 0;\n  ", "\n  overflow-x: hidden;\n  ", "\n  background-repeat: no-repeat;\n  ", "\n  ", "\n  ", "\n  z-index: -1;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  padding: 0 20px;\n  text-align: center;\n"], ["\n  ", "\n  ", "\n  ", "\n  padding: 0 20px;\n  text-align: center;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _buoyCore = __webpack_require__(17);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _buoyTheme = __webpack_require__(4);
	
	var _responsive = __webpack_require__(16);
	
	var _responsive2 = _interopRequireDefault(_responsive);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var HeroSection = _styledComponents2.default.header(_templateObject, _buoyTheme.colors.landingBackground, (0, _responsive2.default)("justify-content", "center", "center", "flex-start", "flex-start"), (0, _responsive2.default)("height", "85vh", "620px", "500px", "440px"));
	
	var HeroImage = _styledComponents2.default.div(_templateObject2, (0, _responsive2.default)("height", "100vh", "735px", "535px", "465px"), function (props) {
	  return (0, _responsive2.default)('background-image', "url(" + props.image.xl + ")", "url(" + props.image.lg + ")", "url(" + props.image.md + ")", "url(" + props.image.sm + ")");
	}, (0, _responsive2.default)("background-position", "42% bottom", "48% bottom", "60% bottom", "60% bottom"), (0, _responsive2.default)("background-size", "auto 95vh", "auto 700px", "auto 350px", "auto 225px"), (0, _responsive2.default)("top", "-10%", "-10", "0", "0"));
	var StyledHeadingOne = (0, _styledComponents2.default)(_buoyCore.HeadingOne)(_templateObject3, (0, _responsive2.default)("margin-top", "0", "0", "124px", "112px"), (0, _responsive2.default)("margin-bottom", "25px", "25px", "12px", "12px"), (0, _responsive2.default)("max-width", "450px", "450px", "350px", "350px"));
	
	var Hero = function Hero(_ref) {
	  var headline = _ref.headline,
	      button = _ref.button,
	      image = _ref.image,
	      symptomCheckerPath = _ref.symptomCheckerPath,
	      innerRef = _ref.innerRef;
	  return _react2.default.createElement(
	    HeroSection,
	    { innerRef: innerRef },
	    _react2.default.createElement(HeroImage, { image: image }),
	    _react2.default.createElement(
	      StyledHeadingOne,
	      null,
	      headline
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { href: (0, _utils.generatePageUrl)(symptomCheckerPath), large: true, arrow: true },
	      button
	    )
	  );
	};
	
	var HeroContainer = function (_React$Component) {
	  _inherits(HeroContainer, _React$Component);
	
	  function HeroContainer(props) {
	    _classCallCheck(this, HeroContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var imgSrc = (0, _utils.getImageUrl)(props.image + "?auto=format,compress&crop=fit&px=16&blur=200");
	
	    _this.state = {
	      image: {
	        sm: imgSrc + "&h=930",
	        md: imgSrc + "&h=1110",
	        lg: imgSrc + "&h=1500",
	        xl: imgSrc + "&h=3000"
	      }
	    };
	    return _this;
	  }
	
	  HeroContainer.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var hdImage = new Image();
	    var imgSrc = (0, _utils.getImageUrl)(this.props.image + "?auto=format,compress&crop=fit");
	    var newState = { image: {} };
	    var screenWidth = window.innerWidth;
	
	    if (screenWidth <= _buoyTheme.breakpoints.sm) {
	      hdImage.src = imgSrc + "&h=950";
	      newState = {
	        image: {
	          sm: hdImage.src,
	          md: imgSrc + "&h=1110",
	          lg: imgSrc + "&h=1500",
	          xl: imgSrc + "&h=3000"
	        }
	      };
	    } else if (screenWidth <= _buoyTheme.breakpoints.md) {
	      hdImage.src = imgSrc + "&h=1110";
	      newState = {
	        image: {
	          sm: hdImage.src,
	          md: hdImage.src,
	          lg: imgSrc + "&h=1500",
	          xl: imgSrc + "&h=3000"
	        }
	      };
	    } else if (screenWidth <= _buoyTheme.breakpoints.lg) {
	      hdImage.src = imgSrc + "&h=1500";
	      newState = {
	        image: {
	          sm: hdImage.src,
	          md: hdImage.src,
	          lg: hdImage.src,
	          xl: imgSrc + "&h=3000"
	        }
	      };
	    } else {
	      hdImage.src = imgSrc + "&h=3000";
	      newState = {
	        image: {
	          sm: hdImage.src,
	          md: hdImage.src,
	          lg: hdImage.src,
	          xl: hdImage.src
	        }
	      };
	    }
	
	    hdImage.onload = function () {
	      _this2.setState(newState);
	    };
	  };
	
	  HeroContainer.prototype.render = function render() {
	    return _react2.default.createElement(Hero, _extends({}, this.props, this.state));
	  };
	
	  return HeroContainer;
	}(_react2.default.Component);
	
	exports.default = HeroContainer;
	module.exports = exports["default"];

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"], ["\n  text-align: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  ", ";\n  ", ";\n  justify-content: space-between;\n  width: 100%;\n  max-width: 900px;\n  text-align: center;\n"], ["\n  display: flex;\n  ", ";\n  ", ";\n  justify-content: space-between;\n  width: 100%;\n  max-width: 900px;\n  text-align: center;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  ", ";\n"], ["\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: auto;\n  height: 80px;\n"], ["\n  position: relative;\n  width: auto;\n  height: 80px;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  background-image: radial-gradient(#FFE4C5 20%, transparent 16%);\n  background-size: 11px 11px;\n  ", "\n"], ["\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  background-image: radial-gradient(#FFE4C5 20%, transparent 16%);\n  background-size: 11px 11px;\n  ", "\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  width: 100%; /* for IE11 compatibility */\n"], ["\n  width: 100%; /* for IE11 compatibility */\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _buoyCore = __webpack_require__(17);
	
	var _responsive = __webpack_require__(16);
	
	var _responsive2 = _interopRequireDefault(_responsive);
	
	var _Section = __webpack_require__(76);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledHeadingTwo = (0, _styledComponents2.default)(_buoyCore.HeadingTwo)(_templateObject);
	
	var InfoContainer = _styledComponents2.default.div(_templateObject2, (0, _responsive2.default)("flex-direction", "row", "row", "row", "column"), (0, _responsive2.default)("align-items", "flex-start", "flex-start", "flex-start", "center"));
	
	var SubSectionContainer = _styledComponents2.default.div(_templateObject3, (0, _responsive2.default)("padding", "20px", "20px", "20px", "40px"));
	
	var Image = _styledComponents2.default.img(_templateObject4);
	var Dots = _styledComponents2.default.div(_templateObject5, (0, _responsive2.default)("width", "60%", "60%", "60%", "20px"), (0, _responsive2.default)("right", "-30%", "-30%", "-30%", "inherit"), (0, _responsive2.default)("top", "55px", "55px", "55px", "89%"), (0, _responsive2.default)("height", "20px", "20px", "20px", "24%"), (0, _responsive2.default)("background-repeat", "repeat-x", "repeat-x", "repeat-x", "repeat-y"));
	
	var SubSectionParagraph = (0, _styledComponents2.default)(_buoyCore.Paragraph)(_templateObject6);
	
	var SubSection = function SubSection(_ref) {
	  var headline = _ref.headline,
	      image = _ref.image,
	      body = _ref.body,
	      last = _ref.last;
	  return _react2.default.createElement(
	    SubSectionContainer,
	    null,
	    !last && _react2.default.createElement(Dots, null),
	    _react2.default.createElement(
	      _responsive.LazyResImage,
	      {
	        src: image,
	        height: 80,
	        width: 80,
	        alt: "A graphic icon for '" + headline + "'"
	      },
	      _react2.default.createElement(Image, null)
	    ),
	    _react2.default.createElement(
	      _buoyCore.HeadingThree,
	      { margin: "16px 0 6px" },
	      headline
	    ),
	    _react2.default.createElement(
	      SubSectionParagraph,
	      { margin: "0", small: true },
	      body
	    )
	  );
	};
	
	var HowItWorks = function HowItWorks(_ref2) {
	  var headline = _ref2.headline,
	      sections = _ref2.sections;
	  return _react2.default.createElement(
	    _Section2.default,
	    null,
	    _react2.default.createElement(
	      StyledHeadingTwo,
	      null,
	      headline
	    ),
	    _react2.default.createElement(
	      InfoContainer,
	      null,
	      sections.map(function (s, i) {
	        return _react2.default.createElement(SubSection, _extends({ key: s.headline }, s, { last: sections.length - 1 === i }));
	      })
	    )
	  );
	};
	
	exports.default = HowItWorks;
	module.exports = exports["default"];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  font-weight: ", ";\n  letter-spacing: 0.9px;\n  text-transform: uppercase;\n  line-height: 1.2;\n  color: ", ";\n  margin: 10px 0 20px 0;\n  display: inline-block;\n  position: relative;\n"], ["\n  ", ";\n  font-weight: ", ";\n  letter-spacing: 0.9px;\n  text-transform: uppercase;\n  line-height: 1.2;\n  color: ", ";\n  margin: 10px 0 20px 0;\n  display: inline-block;\n  position: relative;\n"]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _buoyTheme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Label = _styledComponents2.default.h2(_templateObject, (0, _buoyTheme.fontSize)("label"), _buoyTheme.fontWeight.medium, _buoyTheme.colors.neutralLight);
	
	exports.default = Label;
	module.exports = exports["default"];

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n"], ["\n  position: relative;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  @media (max-width: 600px) {\n    flex-direction: column;\n  }\n  height: 100%;\n"], ["\n  display: flex;\n  @media (max-width: 600px) {\n    flex-direction: column;\n  }\n  height: 100%;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  // margin media queries\n  margin: 5px 8px 0 18px;\n  @media (min-width: 600px) and (max-width: 1100px) {\n    margin: 10px 12px 0 18px;\n  }\n  @media (max-width: 600px) {\n    margin: 5px 14px;\n  }\n  // font size media queries\n  @media (min-width: 600px) {\n    font-size: 36px !important;\n  }\n  @media (max-width: 600px) and (min-width: 450px) {\n    font-size: 24px;\n  }\n  @media (max-width: 450px) {\n    font-size: 20px;\n  }\n"], ["\n  // margin media queries\n  margin: 5px 8px 0 18px;\n  @media (min-width: 600px) and (max-width: 1100px) {\n    margin: 10px 12px 0 18px;\n  }\n  @media (max-width: 600px) {\n    margin: 5px 14px;\n  }\n  // font size media queries\n  @media (min-width: 600px) {\n    font-size: 36px !important;\n  }\n  @media (max-width: 600px) and (min-width: 450px) {\n    font-size: 24px;\n  }\n  @media (max-width: 450px) {\n    font-size: 20px;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  // desktop\n  width: 50%;\n  //   tablet\n  @media (min-width: 600px) and (max-width: 1100px) {\n    width: 35%;\n    height: 100%;\n  }\n  //   mobile\n  @media (max-width: 600px) {\n    width: 100%;\n    height: 30%;\n    margin-bottom: 10px;\n  }\n  background-image: url(\"../../../images/covid19.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%;\n  min-height: 100px;\n"], ["\n  // desktop\n  width: 50%;\n  //   tablet\n  @media (min-width: 600px) and (max-width: 1100px) {\n    width: 35%;\n    height: 100%;\n  }\n  //   mobile\n  @media (max-width: 600px) {\n    width: 100%;\n    height: 30%;\n    margin-bottom: 10px;\n  }\n  background-image: url(\"../../../images/covid19.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%;\n  min-height: 100px;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 50%;\n  // tablet\n  @media (min-width: 600px) and (max-width: 1100px) {\n    width: 65%;\n  }\n  // mobile\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n  @media only screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) {\n    padding: 0 5px;\n  }\n  // iphone 11 pro/X/Xs\n  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {\n    padding: 0 5px;\n  }\n  overflow: scroll;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 50%;\n  // tablet\n  @media (min-width: 600px) and (max-width: 1100px) {\n    width: 65%;\n  }\n  // mobile\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n  @media only screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) {\n    padding: 0 5px;\n  }\n  // iphone 11 pro/X/Xs\n  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {\n    padding: 0 5px;\n  }\n  overflow: scroll;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  max-width 200px;\n  width: 40%;\n  margin: 20px 0 0 18px;\n  @media (max-width: 600px) {\n      display: none;\n  }\n"], ["\n  max-width 200px;\n  width: 40%;\n  margin: 20px 0 0 18px;\n  @media (max-width: 600px) {\n      display: none;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  max-width 150px;\n  margin: 20px 0 20px 15px;\n  @media (min-width: 600px) {\n      display: none;\n  }\n"], ["\n  max-width 150px;\n  margin: 20px 0 20px 15px;\n  @media (min-width: 600px) {\n      display: none;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  @media (max-width: 600px) {\n    flex-direction: column;\n    align-items: center;\n  }\n  align-self: center;\n  width: 95%;\n  @media (max-width: 600px) {\n    margin: 10px auto 0 auto;\n    width: 92.5%;\n  }\n  @media (max-width: 400px) {\n    margin: 0 auto 0 auto;\n    width: 98%;\n  }\n"], ["\n  @media (max-width: 600px) {\n    flex-direction: column;\n    align-items: center;\n  }\n  align-self: center;\n  width: 95%;\n  @media (max-width: 600px) {\n    margin: 10px auto 0 auto;\n    width: 92.5%;\n  }\n  @media (max-width: 400px) {\n    margin: 0 auto 0 auto;\n    width: 98%;\n  }\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 600px) {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 25px;\n  }\n"], ["\n  @media (min-width: 600px) {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 25px;\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"], ["\n  text-align: center;\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin: 15px auto;\n"], ["\n  text-align: center;\n  margin: 15px auto;\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n  width: 10px;\n"], ["\n  width: 10px;\n"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n  width: 90%;\n  height: 2px;\n  background-color: ", ";\n  align-self: center;\n"], ["\n  width: 90%;\n  height: 2px;\n  background-color: ", ";\n  align-self: center;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Modal = __webpack_require__(369);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _buoyTag = __webpack_require__(232);
	
	var _buoyTag2 = _interopRequireDefault(_buoyTag);
	
	var _buoyButton = __webpack_require__(48);
	
	var _buoyTheme = __webpack_require__(4);
	
	var _buoyText = __webpack_require__(20);
	
	var _buoyCore = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// NOTE: this modal is going to be removed very soon
	// created quickly to meet requirements from state
	
	var CovidModalWrapper = _styledComponents2.default.div(_templateObject);
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject2);
	var MainHeading = _styledComponents2.default.div(_templateObject3);
	var ImageWrapper = _styledComponents2.default.div(_templateObject4);
	
	var MainContentWrapper = _styledComponents2.default.div(_templateObject5);
	
	var TagWrapper = _styledComponents2.default.div(_templateObject6);
	
	var MobileTagWrapper = _styledComponents2.default.div(_templateObject7);
	
	var ButtonWrapper = _styledComponents2.default.div(_templateObject8);
	
	var MainButtonWrapper = _styledComponents2.default.div(_templateObject9);
	
	var ParagraphWrapper = _styledComponents2.default.div(_templateObject10);
	
	var LinkWrapper = _styledComponents2.default.div(_templateObject11);
	
	var Separator = _styledComponents2.default.span(_templateObject12);
	var HorizontalDivider = _styledComponents2.default.hr(_templateObject13, _buoyTheme.colors.neutralLighter);
	
	var MA_COVID_URL = "https://www.buoyhealth.com/symptom-checker/?configuration=ma_covid&concern=coronavirus";
	var VA_COVID_URL = "https://www.buoyhealth.com/symptom-checker/?configuration=va_covid&concern=coronavirus";
	var SCF_URL = "https://www.buoyhealth.com/symptom-checker/?concern=coronavirus";
	var COVID_CONTENT_URL = "https://www.buoyhealth.com/diagnoses-a-z/coronavirus";
	
	var CovidModal = function CovidModal(_ref) {
	  var handleModalClose = _ref.handleModalClose;
	  return _react2.default.createElement(
	    CovidModalWrapper,
	    { style: { height: "100%" } },
	    _react2.default.createElement(
	      _Modal2.default,
	      {
	        covidModal: true,
	        showSubmit: false,
	        showCancel: false,
	        closeOnOutsideClick: true,
	        handleModalClose: handleModalClose
	      },
	      _react2.default.createElement(
	        ContentWrapper,
	        null,
	        _react2.default.createElement(
	          MobileTagWrapper,
	          null,
	          _react2.default.createElement(
	            _buoyTag2.default,
	            { tagColor: "#db0000" },
	            "COVID-19 ALERT"
	          )
	        ),
	        _react2.default.createElement(ImageWrapper, null),
	        _react2.default.createElement(
	          MainContentWrapper,
	          null,
	          _react2.default.createElement(
	            TagWrapper,
	            null,
	            _react2.default.createElement(
	              _buoyTag2.default,
	              { tagColor: "#db0000" },
	              "COVID-19 ALERT"
	            )
	          ),
	          _react2.default.createElement(
	            MainHeading,
	            null,
	            "Coronavirus prevention & treatment: You're in the right place"
	          ),
	          _react2.default.createElement(HorizontalDivider, null),
	          _react2.default.createElement(
	            ParagraphWrapper,
	            null,
	            _react2.default.createElement(
	              _buoyText.Paragraph,
	              { style: { "font-weight": "500" } },
	              "Check for COVID-19 symptoms in:"
	            )
	          ),
	          _react2.default.createElement(
	            ButtonWrapper,
	            null,
	            _react2.default.createElement(
	              MainButtonWrapper,
	              null,
	              _react2.default.createElement(
	                _buoyButton.RoundLinkButton,
	                {
	                  href: MA_COVID_URL,
	                  target: "_blank",
	                  onClick: function onClick() {
	                    return window.open(MA_COVID_URL, "_blank");
	                  },
	                  covidModal: true
	                },
	                "Massachusetts (EN/ES)"
	              ),
	              _react2.default.createElement(Separator, null),
	              _react2.default.createElement(
	                _buoyButton.RoundLinkButton,
	                {
	                  href: VA_COVID_URL,
	                  target: "_blank",
	                  onClick: function onClick() {
	                    return window.open(VA_COVID_URL, "_blank");
	                  },
	                  covidModal: true
	                },
	                "Virginia (EN/ES)"
	              )
	            ),
	            _react2.default.createElement(
	              _buoyButton.RoundLinkButton,
	              {
	                backgroundColor: "neutralLightest",
	                textColor: "primary",
	                href: SCF_URL,
	                target: "_blank",
	                onClick: function onClick() {
	                  return window.open(SCF_URL, "_blank");
	                },
	                covidModal: true,
	                secondary: true
	              },
	              "All other states (EN only)"
	            )
	          ),
	          _react2.default.createElement(
	            LinkWrapper,
	            null,
	            _react2.default.createElement(
	              _buoyCore.Link,
	              { href: COVID_CONTENT_URL, target: "_blank" },
	              "Learn about COVID-19"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = CovidModal;
	module.exports = exports["default"];

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 1.5rem;\n  width: 90vw;\n  @media (max-width: 500px) {\n    width: 98vw;\n  }\n  max-width: ", ";\n  ", ";\n  ", ";\n  box-shadow: ", ";\n  ", ";\n  z-index: 9999;\n  transition: transform 0.35s ease-out, opacity 0.15s ease-in;\n  transform: ", ";\n  opacity: ", ";\n"], ["\n  position: relative;\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 1.5rem;\n  width: 90vw;\n  @media (max-width: 500px) {\n    width: 98vw;\n  }\n  max-width: ", ";\n  ", ";\n  ", ";\n  box-shadow: ", ";\n  ", ";\n  z-index: 9999;\n  transition: transform 0.35s ease-out, opacity 0.15s ease-in;\n  transform: ", ";\n  opacity: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    height: 55vh;\n  "], ["\n    height: 55vh;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n      // general device media sizes\n      @media (min-width: 600px) and (max-width: 1100px) {\n        height: 55vh;\n      }\n      @media (min-width: 350px) and (max-width: 600px) {\n        height: auto;\n      }\n      @media (max-height: 650px) {\n          height: 80vh;\n      }\n      @media (min-height: 1100px) and (min-width: 1000px) {\n        height: 60vh;\n      }\n      @media (min-height: 1200px) and (min-width: 1000px) {\n        height: 50vh;\n      }\n      // common devices specifically\n      // iphone8 size\n      @media only screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) {\n        height: 87.5vh;\n        width: 95vw;\n      }\n      // iphone 6/7/8 plus\n      @media only screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) {\n        height: 85vh;\n      }\n      // iphone X/11\n      @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {\n        height: 75vh;\n      }\n      // iphone 11 pro/X/Xs\n      @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {\n        height: 80vh;\n        width: 94vw;\n      }\n      //   max size phones\n      @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {\n        height: 75vh;\n      }\n\n    "], ["\n      // general device media sizes\n      @media (min-width: 600px) and (max-width: 1100px) {\n        height: 55vh;\n      }\n      @media (min-width: 350px) and (max-width: 600px) {\n        height: auto;\n      }\n      @media (max-height: 650px) {\n          height: 80vh;\n      }\n      @media (min-height: 1100px) and (min-width: 1000px) {\n        height: 60vh;\n      }\n      @media (min-height: 1200px) and (min-width: 1000px) {\n        height: 50vh;\n      }\n      // common devices specifically\n      // iphone8 size\n      @media only screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) {\n        height: 87.5vh;\n        width: 95vw;\n      }\n      // iphone 6/7/8 plus\n      @media only screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) {\n        height: 85vh;\n      }\n      // iphone X/11\n      @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {\n        height: 75vh;\n      }\n      // iphone 11 pro/X/Xs\n      @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {\n        height: 80vh;\n        width: 94vw;\n      }\n      //   max size phones\n      @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {\n        height: 75vh;\n      }\n\n    "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  margin-top: 40px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"], ["\n  margin-top: 40px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  ", ";\n  font-family: ", ";\n  display: inline-block;\n  color: #646464;\n\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  ", ";\n  font-family: ", ";\n  display: inline-block;\n  color: #646464;\n\n  &:hover {\n    cursor: pointer;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  line-height: 1.25;\n"], ["\n  line-height: 1.25;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  transition: ", ";\n  z-index: 9998;\n  overflow-y: auto;\n  > * {\n    margin: auto 16px;\n  }\n"], ["\n  position: fixed;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  transition: ", ";\n  z-index: 9998;\n  overflow-y: auto;\n  > * {\n    margin: auto 16px;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _polished = __webpack_require__(200);
	
	var _buoyText = __webpack_require__(20);
	
	var _buoyButton = __webpack_require__(48);
	
	var _buoyButton2 = _interopRequireDefault(_buoyButton);
	
	var _buoyTheme = __webpack_require__(4);
	
	var _buoyCloseIcon = __webpack_require__(56);
	
	var _buoyCloseIcon2 = _interopRequireDefault(_buoyCloseIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var DialogBox = _styledComponents2.default.div(_templateObject, _buoyTheme.colors.white, _buoyTheme.constants.borderRadius, function (props) {
	  return !props.covidModal ? "24.889rem" : "1200px";
	}, function (props) {
	  return props.covidModal && (0, _styledComponents.css)(_templateObject2);
	}, function (props) {
	  return props.covidModal && (0, _styledComponents.css)(_templateObject3);
	}, _buoyTheme.constants.boxShadow, function (props) {
	  return props.covidModal ? "padding: 0" : (0, _buoyTheme.responsive)("padding", "48px 40px 40px", "48px 40px 40px", "48px 40px 40px", "48px 40px 40px", "48px 24px 24px");
	}, function (props) {
	  return props.show ? "scale(1.0)" : "scale(0.9)";
	}, function (props) {
	  return props.show ? "1" : "0";
	});
	
	var Buttons = _styledComponents2.default.div(_templateObject4);
	
	var CancelButton = _styledComponents2.default.a(_templateObject5, (0, _buoyTheme.fontSize)("bodyMain"), _buoyTheme.fontFamily);
	var ModalParagraph = (0, _styledComponents2.default)(_buoyText.Paragraph)(_templateObject6);
	
	var ModalBackground = _styledComponents2.default.div(_templateObject7, function (props) {
	  return props.show ? (0, _polished.transparentize)(0.5, _buoyTheme.colors.neutralDarkest(props)) : "transparent";
	}, function (props) {
	  return props.show ? "background 0.35s ease-in" : "background 0.25s ease-in";
	});
	
	var Dialog = function Dialog(_ref) {
	  var children = _ref.children,
	      heading = _ref.heading,
	      message = _ref.message,
	      showSubmit = _ref.showSubmit,
	      submitEnabled = _ref.submitEnabled,
	      submitText = _ref.submitText,
	      submitClick = _ref.submitClick,
	      showCancel = _ref.showCancel,
	      cancelText = _ref.cancelText,
	      fadeAway = _ref.fadeAway,
	      show = _ref.show,
	      covidModal = _ref.covidModal;
	  return _react2.default.createElement(
	    DialogBox,
	    { onClick: function onClick(e) {
	        return e.stopPropagation();
	      }, show: show, covidModal: covidModal },
	    _react2.default.createElement(
	      _buoyText.HeadingThree,
	      { fontSize: "h3", weight: "light", alignLeft: true, margin: "0" },
	      heading
	    ),
	    message && _react2.default.createElement(
	      ModalParagraph,
	      { margin: "12px 0" },
	      message
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { height: "100%" } },
	      children
	    ),
	    (showSubmit || showCancel) && _react2.default.createElement(
	      Buttons,
	      null,
	      showCancel && _react2.default.createElement(
	        CancelButton,
	        { onClick: fadeAway },
	        cancelText
	      ),
	      showSubmit && _react2.default.createElement(
	        _buoyButton2.default,
	        {
	          margin: "0 0 0 24px",
	          disabled: !submitEnabled,
	          display: "block",
	          onClick: submitClick
	        },
	        submitText
	      )
	    ),
	    _react2.default.createElement(_buoyCloseIcon2.default, {
	      top: "14px",
	      right: "14px",
	      onClick: fadeAway,
	      color: covidModal ? "#196cff" : "black",
	      iconSize: "16px"
	    })
	  );
	};
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    _classCallCheck(this, Modal);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.toggleDialog = function () {
	      // we want a transition effect where the background blurs in first and then
	      // the modal pops in
	      _this.state.showDialog ? _this.setState({ showDialog: false }) : _this.setState({ showDialog: true });
	    };
	
	    _this.toggleBackground = function () {
	      // we want a transition effect where the background blurs in first and then
	      // the modal pops in
	      _this.state.showBackground ? _this.setState({ showBackground: false }) : _this.setState({ showBackground: true });
	    };
	
	    _this.componentDidMount = function () {
	      setTimeout(_this.toggleBackground, 100);
	      setTimeout(_this.toggleDialog, 350);
	    };
	
	    _this.fadeAway = function () {
	      _this.setState({ modalClosed: true });
	      _this.toggleDialog();
	      _this.toggleBackground();
	      _this.props.handleModalClose();
	      setTimeout(_this.props.cancelClick, 350);
	    };
	
	    _this.state = {
	      showDialog: false,
	      showBackground: false,
	      modalClosed: false
	    };
	    return _this;
	  }
	
	  Modal.prototype.render = function render() {
	    return _react2.default.createElement(
	      ModalBackground,
	      {
	        show: this.state.showBackground,
	        onClick: this.props.closeOnOutsideClick && !this.state.modalClosed ? this.fadeAway : null
	      },
	      _react2.default.createElement(Dialog, _extends({
	        fadeAway: this.fadeAway,
	        show: this.state.showDialog
	      }, this.props))
	    );
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = {
	  heading: _propTypes2.default.string.isRequired,
	  message: _propTypes2.default.string,
	  showSubmit: _propTypes2.default.bool,
	  submitEnabled: _propTypes2.default.bool,
	  submitText: _propTypes2.default.string,
	  submitClick: _propTypes2.default.func,
	  showCancel: _propTypes2.default.bool,
	  cancelClick: _propTypes2.default.func.isRequired,
	  cancelText: _propTypes2.default.string,
	  closeOnOutsideClick: _propTypes2.default.bool
	};
	
	Modal.defaultProps = {
	  showSubmit: true,
	  submitEnabled: true,
	  showCancel: true,
	  cancelText: "Cancel",
	  closeOnOutsideClick: false
	};
	
	exports.default = Modal;
	module.exports = exports["default"];

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  ", ";\n  ", ";\n  margin: 0 -20px;\n"], ["\n  background: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  ", ";\n  ", ";\n  margin: 0 -20px;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin-bottom: 12px;\n"], ["\n  ", ";\n  margin-bottom: 12px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 10px;\n  height: 64px;\n"], ["\n  margin-bottom: 10px;\n  height: 64px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _buoyCore = __webpack_require__(17);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _responsive = __webpack_require__(16);
	
	var _responsive2 = _interopRequireDefault(_responsive);
	
	var _buoyTheme = __webpack_require__(4);
	
	var _handshake = __webpack_require__(883);
	
	var _handshake2 = _interopRequireDefault(_handshake);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, _buoyTheme.colors.landingBackground, (0, _responsive2.default)("width", "100vw", "100vw", "100vw", "100vw"), (0, _responsive2.default)("padding", "46px 0 56px", "46px 0 56px", "38px 0 48px", "38px 20px 48px"));
	
	var Body = (0, _styledComponents2.default)(_buoyCore.Paragraph).attrs({
	  small: true,
	  center: true,
	  margin: "0 auto"
	})(_templateObject2, (0, _responsive2.default)("max-width", "520px", "520px", "350px", "340px"), (0, _responsive2.default)("margin-bottom", "20px", "20px", "20px", "20px"));
	
	var Heading = (0, _styledComponents2.default)(_buoyCore.HeadingTwo)(_templateObject3, (0, _buoyTheme.fontSize)("h3"));
	
	var HandShakeIcon = _styledComponents2.default.img(_templateObject4);
	
	var Partner = function Partner(_ref) {
	  var headline = _ref.headline,
	      body = _ref.body,
	      button = _ref.button;
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(HandShakeIcon, { src: _handshake2.default, alt: "Partner with Buoy" }),
	    _react2.default.createElement(
	      Heading,
	      null,
	      headline
	    ),
	    _react2.default.createElement(
	      Body,
	      null,
	      body
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        ghost: true,
	        backgroundColor: "transparent",
	        color: "landingBlue",
	        href: (0, _utils.generatePageUrl)(button.link)
	      },
	      button.text
	    )
	  );
	};
	
	exports.default = Partner;
	module.exports = exports["default"];

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: block;\n  width: 100%;\n  position: relative;\n  max-width: 900px;\n  margin: 0 auto;\n  text-align: center;\n"], ["\n  display: block;\n  width: 100%;\n  position: relative;\n  max-width: 900px;\n  margin: 0 auto;\n  text-align: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: block;\n  text-align: center;\n  max-width: 900px;\n  margin: 0 auto;\n"], ["\n  display: block;\n  text-align: center;\n  max-width: 900px;\n  margin: 0 auto;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  display: block;\n  width: 100%;\n\n  @media (min-width: 500px) {\n    display: inline-block;\n    width: auto;\n    margin: 11px 22px;\n  }\n"], ["\n  text-align: center;\n  display: block;\n  width: 100%;\n\n  @media (min-width: 500px) {\n    display: inline-block;\n    width: auto;\n    margin: 11px 22px;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n"], ["\n  display: block;\n  position: relative;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  height: ", ";\n  max-width: 100%;\n  margin: 11px 0;\n\n  @media (min-width: 500px) {\n    margin: 6px 0;\n    height: auto;\n    max-width: none;\n  }\n"], ["\n  display: inline-block;\n  height: ", ";\n  max-width: 100%;\n  margin: 11px 0;\n\n  @media (min-width: 500px) {\n    margin: 6px 0;\n    height: auto;\n    max-width: none;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Label = __webpack_require__(219);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Section = __webpack_require__(76);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _responsive = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PressContainer = _styledComponents2.default.div(_templateObject);
	
	var PressMentions = _styledComponents2.default.div(_templateObject2);
	
	var PressMention = _styledComponents2.default.div(_templateObject3);
	
	var PressLink = _styledComponents2.default.a(_templateObject4);
	
	var Logo = _styledComponents2.default.img(_templateObject5, function (props) {
	  return props.height || "22px";
	});
	
	var Press = function Press(_ref) {
	  var headline = _ref.headline,
	      mentions = _ref.mentions;
	  return _react2.default.createElement(
	    _Section2.default,
	    { small: true, color: "neutralLightest" },
	    _react2.default.createElement(
	      PressContainer,
	      null,
	      _react2.default.createElement(
	        _Label2.default,
	        null,
	        headline
	      ),
	      _react2.default.createElement(
	        PressMentions,
	        null,
	        mentions.map(function (mention, index) {
	          return _react2.default.createElement(
	            PressMention,
	            { key: index },
	            _react2.default.createElement(
	              PressLink,
	              { href: mention.url, target: "_blank" },
	              _react2.default.createElement(
	                _responsive.LazyResImage,
	                {
	                  src: mention.logo,
	                  height: mention.height,
	                  alt: "Buoy Health is featured by " + mention.publisher + "."
	                },
	                _react2.default.createElement(Logo, null)
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = Press;
	module.exports = exports["default"];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  ", ";\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  ", ";\n  ", ";\n"]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _responsive = __webpack_require__(16);
	
	var _responsive2 = _interopRequireDefault(_responsive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = _styledComponents2.default.section(_templateObject, function (props) {
	  return props.small ? (0, _responsive2.default)("padding", "56px 20px", "56px 20px", "48px 20px", "48px 20px") : (0, _responsive2.default)("padding", "110px 16px", "110px 16px", "80px 16px", "64px 16px");
	}, function (props) {
	  return props.color && "background-color: " + props.theme.colors[props.color] + ";";
	});
	
	exports.default = Section;
	module.exports = exports["default"];

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  overflow: hidden;\n  margin: 20px 10px 20px;\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);\n  transition: transform 0.5s;\n  text-decoration: none;\n  &:hover {\n    transform: scale(1.05);\n  }\n  ", "\n  ", "\n  ", "\n  \n  &:nth-child(1) {\n    ", "\n  } \n\n  &:nth-child(3) {\n    ", "\n  } \n\n  &:nth-child(1),\n  &:nth-child(2) {\n    display: block;\n  }\n"], ["\n  background-color: ", ";\n  overflow: hidden;\n  margin: 20px 10px 20px;\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);\n  transition: transform 0.5s;\n  text-decoration: none;\n  &:hover {\n    transform: scale(1.05);\n  }\n  ", "\n  ", "\n  ", "\n  \n  &:nth-child(1) {\n    ", "\n  } \n\n  &:nth-child(3) {\n    ", "\n  } \n\n  &:nth-child(1),\n  &:nth-child(2) {\n    display: block;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding: 16px 16px 20px 16px;\n"], ["\n  padding: 16px 16px 20px 16px;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n  font-weight: ", ";\n  color: ", ";\n  display: flex;\n  text-decoration: none;\n  align-items: center;\n"], ["\n  ", "\n  font-weight: ", ";\n  color: ", ";\n  display: flex;\n  text-decoration: none;\n  align-items: center;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  ", " height: auto;\n"], ["\n  ", " height: auto;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  margin-left: 6px;\n  height: 11px;\n"], ["\n  margin-left: 6px;\n  height: 11px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _buoyTheme = __webpack_require__(4);
	
	var _buoyCore = __webpack_require__(17);
	
	var _arrow = __webpack_require__(884);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _responsive = __webpack_require__(16);
	
	var _responsive2 = _interopRequireDefault(_responsive);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.a(_templateObject, _buoyTheme.colors.white, (0, _responsive2.default)("width", "300px", "300px", "50%", "280px"), (0, _responsive2.default)("flex-basis", "auto", "auto", "50%", "auto"), (0, _responsive2.default)("display", "block", "block", "none", "block"), (0, _responsive2.default)("margin-left", "0px", "0px", "0px", "10px"), (0, _responsive2.default)("margin-right", "0px", "0px", "0px", "10px"));
	
	var InnerContainer = _styledComponents2.default.div(_templateObject2);
	
	var Link = _styledComponents2.default.div(_templateObject3, (0, _buoyTheme.fontSize)("bodyMain"), _buoyTheme.fontWeight.regular, _buoyTheme.colors.primary);
	
	var SymptomImage = _styledComponents2.default.img(_templateObject4, (0, _responsive2.default)("width", "300px", "300px", "100%", "100%"));
	
	var LinkArrow = _styledComponents2.default.img(_templateObject5);
	
	var Symptom = function Symptom(_ref) {
	  var headline = _ref.headline,
	      body = _ref.body,
	      linkText = _ref.linkText,
	      url = _ref.url,
	      image = _ref.image;
	  return _react2.default.createElement(
	    Container,
	    { href: (0, _utils.generatePageUrl)(url) },
	    _react2.default.createElement(
	      _responsive.LazyResImage,
	      { src: image.src, alt: image.alt, width: 300 },
	      _react2.default.createElement(SymptomImage, null)
	    ),
	    _react2.default.createElement(
	      InnerContainer,
	      null,
	      _react2.default.createElement(
	        _buoyCore.HeadingThree,
	        { alignLeft: true, margin: "0px 0px 4px" },
	        headline
	      ),
	      _react2.default.createElement(
	        _buoyCore.Paragraph,
	        { small: true, margin: "0 0 10px" },
	        body
	      ),
	      _react2.default.createElement(
	        Link,
	        null,
	        linkText,
	        " ",
	        _react2.default.createElement(LinkArrow, { src: _arrow2.default })
	      )
	    )
	  );
	};
	
	exports.default = Symptom;
	module.exports = exports["default"];

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTQgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjEgKDUxMTQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5JY29uIDogYXJyb3ctcmlnaHQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iSFAiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9IjRfSFAtZ2lnYW50aWMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01ODYuMDAwMDAwLCAtMzM5NC4wMDAwMDApIiBzdHJva2U9IiMxOTZjZmYiIHN0cm9rZS13aWR0aD0iMS4yNSI+CiAgICAgICAgICAgIDxnIGlkPSJJY29uLTotYXJyb3ctcmlnaHQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU5My41MDAwMDAsIDM0MDAuMDAwMDAwKSBzY2FsZSgtMSwgMSkgcm90YXRlKC0xODAuMDAwMDAwKSB0cmFuc2xhdGUoLTU5My41MDAwMDAsIC0zNDAwLjAwMDAwMCkgdHJhbnNsYXRlKDU4Ny4wMDAwMDAsIDMzOTUuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iU3Ryb2tlLTUyIiBwb2ludHM9IjEyLjMxOTE3NDUgNC45NTQxNjY4MSA3LjMzODU4NTQ5IC00Ljk3Mzc5OTE1ZS0xNSI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTAuNDMzMzMzMzMzLDQuOTU0MTY2ODEgTDExLjgzOTIwODYsNC45NTQxNjY4MSIgaWQ9IlN0cm9rZS01NCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTEyLjMxOTE3NDUsNC45NTQxNjY4MSBMNy4zMzg1ODU0OSw5LjkwODMzMzYyIiBpZD0iU3Ryb2tlLTU2Ij48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"], ["\n  text-align: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  ", ";\n  align-items: center;\n  ", ";\n  ", ";\n  width: 100%;\n  max-width: 980px;\n  padding: 10px 0 20px;\n"], ["\n  display: flex;\n  ", ";\n  align-items: center;\n  ", ";\n  ", ";\n  width: 100%;\n  max-width: 980px;\n  padding: 10px 0 20px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Section = __webpack_require__(76);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _buoyCore = __webpack_require__(17);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Symptom = __webpack_require__(373);
	
	var _Symptom2 = _interopRequireDefault(_Symptom);
	
	var _responsive = __webpack_require__(16);
	
	var _responsive2 = _interopRequireDefault(_responsive);
	
	var _utils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledHeadingTwo = (0, _styledComponents2.default)(_buoyCore.HeadingTwo)(_templateObject);
	
	var SymptomContainer = _styledComponents2.default.div(_templateObject2, (0, _responsive2.default)("flex-direction", "row", "row", "row", "column"), (0, _responsive2.default)("justify-content", "space-between", "space-between", "flex-start", "center"), (0, _responsive2.default)("overflow-x", "none", "none", "scroll", "none"));
	
	var Symptoms = function Symptoms(_ref) {
	  var headline = _ref.headline,
	      button = _ref.button,
	      sections = _ref.sections,
	      symptomsAtoZPath = _ref.symptomsAtoZPath;
	  return _react2.default.createElement(
	    _Section2.default,
	    { color: "neutralLightest" },
	    _react2.default.createElement(
	      StyledHeadingTwo,
	      null,
	      headline
	    ),
	    _react2.default.createElement(
	      SymptomContainer,
	      null,
	      sections.map(function (s, i) {
	        return _react2.default.createElement(_Symptom2.default, _extends({ key: s.headline }, s));
	      })
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { large: true, href: (0, _utils.generatePageUrl)(symptomsAtoZPath) },
	      button
	    )
	  );
	};
	
	exports.default = Symptoms;
	module.exports = exports["default"];

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _buoyBottomBanner = __webpack_require__(391);
	
	var _buoyUniversalNav = __webpack_require__(109);
	
	var _buoyUniversalNav2 = _interopRequireDefault(_buoyUniversalNav);
	
	var _buoyFooter = __webpack_require__(108);
	
	var _buoyFooter2 = _interopRequireDefault(_buoyFooter);
	
	var _reactWaypoint = __webpack_require__(849);
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _Head = __webpack_require__(95);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _Hero = __webpack_require__(366);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _HowItWorks = __webpack_require__(367);
	
	var _HowItWorks2 = _interopRequireDefault(_HowItWorks);
	
	var _Enterprise = __webpack_require__(363);
	
	var _Enterprise2 = _interopRequireDefault(_Enterprise);
	
	var _About = __webpack_require__(356);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Press = __webpack_require__(371);
	
	var _Press2 = _interopRequireDefault(_Press);
	
	var _Symptoms = __webpack_require__(374);
	
	var _Symptoms2 = _interopRequireDefault(_Symptoms);
	
	var _constants = __webpack_require__(44);
	
	var _brands = __webpack_require__(94);
	
	var _Source = __webpack_require__(93);
	
	var _Source2 = _interopRequireDefault(_Source);
	
	var _CovidModal = __webpack_require__(368);
	
	var _CovidModal2 = _interopRequireDefault(_CovidModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data,
	      onLeaveNav = _ref.onLeaveNav,
	      onEnterNav = _ref.onEnterNav,
	      onLeaveHero = _ref.onLeaveHero,
	      onEnterHero = _ref.onEnterHero,
	      viewedCookiePolicy = _ref.viewedCookiePolicy,
	      submitViewedCookiePolicy = _ref.submitViewedCookiePolicy,
	      brand = _ref.brand,
	      topNavShadow = _ref.topNavShadow,
	      topNavColor = _ref.topNavColor,
	      topNavGhostButton = _ref.topNavGhostButton,
	      topNavLogoSize = _ref.topNavLogoSize,
	      topNavTransform = _ref.topNavTransform,
	      showCovidModal = _ref.showCovidModal,
	      handleModalClose = _ref.handleModalClose;
	
	  var landingCopy = data.allDataJson.edges[0].node;
	  var products = data.allProductsJson.edges;
	  var site = data.site.siteMetadata;
	
	  var onCloseCookieBanner = function onCloseCookieBanner() {
	    submitViewedCookiePolicy(true);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Head2.default, { data: data }),
	    _react2.default.createElement(_buoyUniversalNav2.default, {
	      baseUrl: _constants.BUOY_SITE_URL,
	      brand: brand,
	      loggedIn: false,
	      prod: _constants.IS_PRODUCTION,
	      topNavShadow: topNavShadow,
	      topNavColor: topNavColor,
	      topNavGhostButton: topNavGhostButton,
	      topNavLogoSize: topNavLogoSize,
	      topNavTransform: topNavTransform
	    }),
	    _react2.default.createElement(_reactWaypoint2.default, { onLeave: onLeaveNav, onEnter: onEnterNav }),
	    _react2.default.createElement(
	      _reactWaypoint2.default,
	      { onLeave: onLeaveHero, onEnter: onEnterHero },
	      _react2.default.createElement(_Hero2.default, _extends({}, landingCopy.hero, {
	        symptomCheckerPath: site.symptomCheckerPath
	      }))
	    ),
	    showCovidModal && _react2.default.createElement(_CovidModal2.default, { handleModalClose: handleModalClose }),
	    _react2.default.createElement(_HowItWorks2.default, landingCopy.howItWorks),
	    _react2.default.createElement(_Press2.default, landingCopy.press),
	    _react2.default.createElement(_Enterprise2.default, _extends({}, landingCopy.enterprise, { products: products })),
	    _react2.default.createElement(_About2.default, _extends({}, landingCopy.about, {
	      symptomCheckerPath: site.symptomCheckerPath
	    })),
	    _react2.default.createElement(_Symptoms2.default, _extends({}, landingCopy.symptoms, {
	      symptomsAtoZPath: site.symptomsAtoZPath
	    })),
	    viewedCookiePolicy === false && _react2.default.createElement(_buoyBottomBanner.CookieBannerContainer, {
	      prod: _constants.IS_PRODUCTION,
	      onClick: onCloseCookieBanner
	    }),
	    _react2.default.createElement(_buoyFooter2.default, { baseUrl: _constants.BUOY_SITE_URL })
	  );
	};
	
	var IndexContainer = function (_React$Component) {
	  _inherits(IndexContainer, _React$Component);
	
	  function IndexContainer() {
	    _classCallCheck(this, IndexContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.handleMassModalClose = function () {
	      _this.setState({ showCovidModal: false });
	    };
	
	    _this.setBrand = function () {
	      var subdomain = (0, _brands.getSubdomain)();
	      if (!subdomain) {
	        return Promise.resolve();
	      }
	      return _Source2.default.brand(subdomain).then(function (data) {
	        if (data && data.name) {
	          _this.setState({ brand: subdomain });
	        }
	
	        // Brand-specific redirect to avoid landing page.
	        if (subdomain) {
	          if (subdomain === "nyt" || subdomain === "houstonmethodist") {
	            window.location.replace(_constants.BUOY_SITE_URL + "/dashboard/");
	          } else {
	            window.location.replace(_constants.BUOY_SITE_URL + "/symptom-checker/");
	          }
	        }
	      }).catch(function (error) {
	        console.log("Can't resolve brand: " + error);
	        return Promise.resolve();
	      });
	    };
	
	    _this.onLeaveNav = function () {
	      _this.setState({ pastNav: true });
	    };
	
	    _this.onEnterNav = function () {
	      _this.setState({ pastNav: false });
	    };
	
	    _this.onLeaveHero = function () {
	      _this.setState({ inHero: false });
	    };
	
	    _this.onEnterHero = function () {
	      _this.setState({ inHero: true });
	    };
	
	    _this.submitViewedCookiePolicy = function () {
	      _Source2.default.updateViewedCookiePolicy(true).then(function (data) {
	        _this.setState({ viewedCookiePolicy: true });
	      });
	    };
	
	    _this.state = {
	      pastNav: false,
	      inHero: true,
	      viewedCookiePolicy: false,
	      brand: undefined,
	      showCovidModal: true
	    };
	
	    _this.restorePositionHandler = _this.restorePositionHandler.bind(_this);
	    _this.handleMassModalClose = _this.handleMassModalClose.bind(_this);
	    return _this;
	  }
	
	  IndexContainer.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    // Ensure site url is updated once we have access to window.location
	    (0, _constants.setBaseUrl)();
	    // Brand is kept in state and validated/updated here for SSR
	    this.setBrand();
	
	    window.onbeforeunload = function () {
	      window.scrollTo(0, 0);
	    };
	
	    window.addEventListener("hashchange", function (event) {
	      if (event.newURL === _constants.BUOY_SITE_URL + "/") {
	        window.scrollTo(0, 0);
	      }
	    }, false);
	
	    _Source2.default.getCookiePolicyViewed().then(function (data) {
	      if (data && data.viewed_cookie_policy) {
	        _this2.setState({ viewedCookiePolicy: data.viewed_cookie_policy });
	      }
	    });
	
	    window.addEventListener("scroll", this.restorePositionHandler);
	  };
	
	  IndexContainer.prototype.restorePositionHandler = function restorePositionHandler() {
	    // This method is needed for when a user loads the page, either by refresh
	    // or forward/back buttons, and the window is not scrolled to the top.
	    this.setState({
	      pastNav: !(window.pageYOffset === 0)
	    });
	    window.removeEventListener("scroll", this.restorePositionHandler);
	  };
	
	  IndexContainer.prototype.render = function render() {
	    var topNavColor = this.state.pastNav ? null : "transparent";
	    var topNavLogoSize = this.state.pastNav ? "small" : "big";
	    var topNavTransform = this.state.pastNav ? null : "translateY(20px)";
	
	    return _react2.default.createElement(IndexPage, _extends({}, this.props, this.state, {
	      brand: this.state.brand,
	      onEnterNav: this.onEnterNav,
	      onLeaveNav: this.onLeaveNav,
	      onEnterHero: this.onEnterHero,
	      onLeaveHero: this.onLeaveHero,
	      viewedCookiePolicy: this.state.viewedCookiePolicy,
	      submitViewedCookiePolicy: this.submitViewedCookiePolicy,
	      topNavShadow: this.state.pastNav,
	      topNavColor: topNavColor,
	      topNavGhostButton: this.state.inHero,
	      topNavLogoSize: topNavLogoSize,
	      topNavTransform: topNavTransform,
	      handleModalClose: this.handleMassModalClose
	    }));
	  };
	
	  return IndexContainer;
	}(_react2.default.Component);
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = IndexContainer;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-1bc67bcb5ed04ab0b1a8.js